import { useEffect } from 'react';

export function useSubscriptionDetails(subscriptionsDetails, setSubscriptionsDetails) {
	useEffect(() => {
		if (subscriptionsDetails.length === 0) {
			const jsonDataScripts = document.querySelector('script.main__data');
			if (!jsonDataScripts?.innerHTML) return;
			const jsonData = JSON.parse(jsonDataScripts.innerHTML);
			const newFormat = jsonData.map((item) => {
				const newObject = {};
				newObject['lbs'] = {
					min: item.weight_in_lbs_start,
					max: item.weight_in_lbs_stop,
				};
				newObject['kg'] = {
					min: item.weight_in_kg_start,
					max: item.weight_in_kg_stop,
				};
				newObject.selected = false;
				newObject.subscription_plans = [...item?.subscription_plans];
				return newObject;
			});

			setSubscriptionsDetails([...newFormat]);
		}
	}, []);
}
